import "./styles.scss";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";

import { useApp } from "context/app";
import { useNotifications } from "context/notifications";

import Table from "components/Table";
import NotificationsModal from "../Modal";

import notificationRender, {
  getNotificationTitle,
  isNewTaskNotification,
} from "libs/notification_render";

const mainClass = "notifications-table";

const NotificationsTable = ({ setWebsiteInfoId }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { user } = useApp();
  const { data, readHandler, loading, filters, filterHandler } =
    useNotifications();

  const [notification_modal, setNotificationModal] = useState(null);

  const table_data = {
    keys: [
      {
        key: "created_at",
        value: t("Date"),
      },
      {
        key: "website",
        value: t("Website [SHORT]"),
      },
      {
        key: "title",
        sort_key: false,
        value: t("Title"),
      },
      {
        key: "category",
        sort_key: false,
        value: t("Category"),
      },
      {
        key: "template",
        sort_key: false,
        value: t("Message"),
      },
      {
        key: "notification_status",
        sort_key: false,
        value: "Status",
      },
      {
        key: "details",
        sort_key: false,
        value: t("Details"),
      },
    ],
    items: data?.map(
      ({
        _id,
        template,
        created_at,
        website,
        status,
        custom_text,
        context,
        href,
        task,
      }) => {
        const taskAddedToUser = template === 21;
        const isNewTask = isNewTaskNotification(template);
        const message =
          custom_text || notificationRender(template, context, t)?.text;

        return [
          {
            key: "created_at",
            value: moment(created_at)?.format("LL"),
          },
          {
            key: "website",
            type: "clickable_text",
            value: {
              label: website?.website,
              icon: false,
              onclick: () =>
                user?.type === "client"
                  ? navigate(`/websites/${website?._id}`)
                  : setWebsiteInfoId(website?._id),
            },
          },
          {
            key: "title",
            value: getNotificationTitle({ template, context, task }, t),
          },
          {
            key: "category",
            type: "pill",
            value: {
              data: {
                label: t(
                  template === 17 ||
                    template === 18 ||
                    template === 19 ||
                    template === 20 ||
                    taskAddedToUser
                    ? "Task"
                    : template === 28
                      ? "Registration"
                      : "Website [SHORT]",
                ),
                color:
                  template === 17 ||
                  template === 18 ||
                  template === 19 ||
                  template === 20 ||
                  taskAddedToUser
                    ? "yellow"
                    : template === 28
                      ? "blue"
                      : "green",
              },
            },
          },
          {
            key: "template",
            type: "html",
            value: isNewTask ? task?.description : message,
          },
          {
            key: "notification_status",
            type: "status",
            value: {
              status: status === 1,
              onclick: () => readHandler(_id, status === 1 ? 0 : 1),
            },
          },
          {
            key: "details",
            type: "clickable_text",
            value: {
              label: t("View"),
              onclick: () => {
                readHandler(_id, 1);
                setNotificationModal({
                  id: _id,
                  text: message,
                  href,
                  task,
                });
              },
            },
          },
        ];
      },
    ),
  };

  return (
    <>
      <div className={mainClass}>
        <Table
          data={table_data}
          loading={!!loading}
          sort={filters?.sort}
          setSort={(value) => filterHandler("sort", value)}
        />
      </div>
      {!!notification_modal && (
        <NotificationsModal
          userType={user?.type}
          data={notification_modal}
          setWebsiteInfoId={setWebsiteInfoId}
          onClose={() => setNotificationModal(null)}
        />
      )}
    </>
  );
};

export default NotificationsTable;
